import { BlogDataExtended } from "@/components/Admin/Blog/interface";
import { BlogArticle } from "@/components/Blog/BlogArticle";
import { BlogLayout } from "@/components/Blog/BlogLayout";
import generateRssFeed from "@/utils/generateRssFeed";
import { getFirestoreBlogs } from "@/utils/getFirestoreBlogs";
import {
  SidebarMetaInfo,
  getSidebarMetaInfo,
} from "@/utils/getSidebarMetaInfo";
import { GetStaticProps, InferGetStaticPropsType } from "next";
import { NextSeo } from "next-seo";
import css from "./blog.module.css";

export default function Blog({
  blogs,
  sidebarMetaInfo,
}: InferGetStaticPropsType<typeof getStaticProps>) {
  return (
    <>
      <NextSeo
        title="Wofm | Блог"
        description={
          "Список всех публикаций: " + blogs.map((i) => i.title).join(" | ")
        }
      />
      <BlogLayout sidebarMetaInfo={sidebarMetaInfo}>
        <div className={css.articles}>
          {blogs.map((blog) => (
            <BlogArticle {...blog} key={blog.id} />
          ))}
        </div>
      </BlogLayout>
    </>
  );
}

export const getStaticProps: GetStaticProps<{
  blogs: (Partial<BlogDataExtended> & { id: string })[];
  sidebarMetaInfo: SidebarMetaInfo;
}> = async () => {
  const blogs = await getFirestoreBlogs();

  await generateRssFeed(blogs);

  const sidebarMetaInfo = await getSidebarMetaInfo();

  return {
    props: {
      blogs,
      sidebarMetaInfo,
    },
  };
};
